// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/EYInterstate-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/EYInterstate-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/EYInterstate-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/fonts/EYInterstate-BoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/fonts/EYInterstate-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../images/error-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../images/success-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../images/warning-icon.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../images/info-icon.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* rastwe: 10/17/17 - I'm adding an @import here to point at the
 *  EY Online Style Guide. This is required because of some issues with
 *  The "extract-text-webpack-plugin", or webpack itself. In either case,
 *  relying on the @import order instead of webpack fixes the issue.
 *  TODO: undo this later, and just refer to the OSG in the top-level
 *  component. */
/**
 * Global LESS variables
 */
/* Colors */
/* Layout */
.global-lh-pd-fs {
  padding: 0 10px;
}
:root {
  --px-0: 0;
  --px-0_1: 0.00714rem;
  --px-0_2: 0.01429rem;
  --px-0_3: 0.02143rem;
  --px-0_4: 0.02857rem;
  --px-0_5: 0.03571rem;
  --px-0_6: 0.04286rem;
  --px-0_7: 0.05rem;
  --px-0_8: 0.05714rem;
  --px-0_9: 0.06429rem;
  --px-1: 0.07143rem;
  --px-1_5: 0.10714rem;
  --px-2: 0.14286rem;
  --px-2_5: 0.17857rem;
  --px-3: 0.21429rem;
  --px-3_5: 0.25rem;
  --px-3_7: 0.26429rem;
  --px-4: 0.28571rem;
  --px-4_5: 0.32143rem;
  --px-5: 0.35714rem;
  --px-6: 0.42857rem;
  --px-6_5: 0.46429rem;
  --px-7: 0.5rem;
  --px-7_5: 0.53571rem;
  --px-8: 0.57143rem;
  --px-8_5: 0.60714rem;
  --px-9: 0.64286rem;
  --px-10: 0.71429rem;
  --px-11: 0.78571rem;
  --px-11_5: 0.82143rem;
  --px-12: 0.85714rem;
  --px-12_5: 0.89286rem;
  --px-12_6: 0.9rem;
  --px-13: 0.92857rem;
  --px-13_5: 0.96429rem;
  --px-14: 1rem;
  --px-14_4: 1.02857rem;
  --px-15: 1.07143rem;
  --px-15_5: 1.10714rem;
  --px-16: 1.14286rem;
  --px-16_5: 1.17857rem;
  --px-16_8: 1.2rem;
  --px-17: 1.21429rem;
  --px-17_5: 1.25rem;
  --px-18: 1.28571rem;
  --px-19: 1.35714rem;
  --px-19_2: 1.37143rem;
  --px-20: 1.42857rem;
  --px-21: 1.5rem;
  --px-21_5: 1.53571rem;
  --px-22: 1.57143rem;
  --px-22_5: 1.60714rem;
  --px-23: 1.64286rem;
  --px-23_5: 1.67857rem;
  --px-24: 1.71429rem;
  --px-25: 1.78571rem;
  --px-26: 1.85714rem;
  --px-27: 1.92857rem;
  --px-28: 2rem;
  --px-29: 2.07143rem;
  --px-30: 2.14286rem;
  --px-31: 2.21429rem;
  --px-32: 2.28571rem;
  --px-33: 2.35714rem;
  --px-34: 2.42857rem;
  --px-35: 2.5rem;
  --px-36: 2.57143rem;
  --px-37: 2.64286rem;
  --px-38: 2.71429rem;
  --px-39: 2.78571rem;
  --px-40: 2.85714rem;
  --px-41: 2.92857rem;
  --px-42: 3rem;
  --px-43: 3.07143rem;
  --px-44: 3.14286rem;
  --px-45: 3.21429rem;
  --px-46: 3.28571rem;
  --px-47: 3.35714rem;
  --px-48: 3.42857rem;
  --px-49: 3.5rem;
  --px-50: 3.57143rem;
  --px-52: 3.71429rem;
  --px-53: 3.78571rem;
  --px-54: 3.85714rem;
  --px-55: 3.92857rem;
  --px-56: 4rem;
  --px-57: 4.07143rem;
  --px-58: 4.14286rem;
  --px-60: 4.28571rem;
  --px-61: 4.35714rem;
  --px-62: 4.42857rem;
  --px-64: 4.57143rem;
  --px-65: 4.64286rem;
  --px-66: 4.71429rem;
  --px-67: 4.78571rem;
  --px-68: 4.85714rem;
  --px-70: 5rem;
  --px-71: 5.07143rem;
  --px-72: 5.14286rem;
  --px-74: 5.28571rem;
  --px-75: 5.35714rem;
  --px-76: 5.42857rem;
  --px-77: 5.5rem;
  --px-78: 5.57143rem;
  --px-80: 5.71429rem;
  --px-82: 5.85714rem;
  --px-83: 5.92857rem;
  --px-84: 6rem;
  --px-85: 6.07143rem;
  --px-87: 6.21429rem;
  --px-88: 6.28571rem;
  --px-90: 6.42857rem;
  --px-91_5: 6.53571rem;
  --px-92: 6.57143rem;
  --px-94: 6.71429rem;
  --px-95: 6.78571rem;
  --px-98: 7rem;
  --px-100: 7.14286rem;
  --px-101: 7.21429rem;
  --px-102: 7.28571rem;
  --px-105: 7.5rem;
  --px-108: 7.71429rem;
  --px-110: 7.85714rem;
  --px-112: 8rem;
  --px-115: 8.21429rem;
  --px-116: 8.28571rem;
  --px-120: 8.57143rem;
  --px-121: 8.64286rem;
  --px-122: 8.71429rem;
  --px-123: 8.78571rem;
  --px-125: 8.92857rem;
  --px-126: 9rem;
  --px-127: 9.07143rem;
  --px-130: 9.28571rem;
  --px-133: 9.5rem;
  --px-134: 9.57143rem;
  --px-135: 9.64286rem;
  --px-136: 9.71429rem;
  --px-138: 9.85714rem;
  --px-140: 10rem;
  --px-142: 10.14286rem;
  --px-145: 10.35714rem;
  --px-149: 10.64286rem;
  --px-150: 10.71429rem;
  --px-154: 11rem;
  --px-155: 11.07143rem;
  --px-158: 11.28571rem;
  --px-160: 11.42857rem;
  --px-162: 11.57143rem;
  --px-163: 11.64286rem;
  --px-165: 11.78571rem;
  --px-166: 11.85714rem;
  --px-168: 12rem;
  --px-170: 12.14286rem;
  --px-173: 12.35714rem;
  --px-175: 12.5rem;
  --px-176: 12.57143rem;
  --px-178: 12.71429rem;
  --px-180: 12.85714rem;
  --px-184: 13.14286rem;
  --px-185: 13.21429rem;
  --px-186: 13.28571rem;
  --px-187: 13.35714rem;
  --px-188: 13.42857rem;
  --px-190: 13.57143rem;
  --px-191: 13.64286rem;
  --px-193: 13.78571rem;
  --px-194: 13.85714rem;
  --px-195: 13.92857rem;
  --px-198: 14.14286rem;
  --px-200: 14.28571rem;
  --px-205: 14.64286rem;
  --px-206: 14.71429rem;
  --px-207: 14.78571rem;
  --px-208: 14.85714rem;
  --px-210: 15rem;
  --px-211: 15.07143rem;
  --px-211_5: 15.10714rem;
  --px-212: 15.14286rem;
  --px-214: 15.28571rem;
  --px-215: 15.35714rem;
  --px-216: 15.42857rem;
  --px-220: 15.71429rem;
  --px-225: 16.07143rem;
  --px-230: 16.42857rem;
  --px-232: 16.57143rem;
  --px-235: 16.78571rem;
  --px-240: 17.14286rem;
  --px-244: 17.42857rem;
  --px-245: 17.5rem;
  --px-250: 17.85714rem;
  --px-251: 17.92857rem;
  --px-252: 18rem;
  --px-255: 18.21429rem;
  --px-257: 18.35714rem;
  --px-260: 18.57143rem;
  --px-265: 18.92857rem;
  --px-270: 19.28571rem;
  --px-272: 19.42857rem;
  --px-275: 19.64286rem;
  --px-280: 20rem;
  --px-282: 20.14286rem;
  --px-285: 20.35714rem;
  --px-290: 20.71429rem;
  --px-293: 20.92857rem;
  --px-300: 21.42857rem;
  --px-305: 21.78571rem;
  --px-310: 22.14286rem;
  --px-315: 22.5rem;
  --px-316: 22.57143rem;
  --px-320: 22.85714rem;
  --px-322: 23rem;
  --px-324: 23.14286rem;
  --px-325: 23.21429rem;
  --px-328: 23.42857rem;
  --px-330: 23.57143rem;
  --px-340: 24.28571rem;
  --px-350: 25rem;
  --px-354: 25.28571rem;
  --px-355: 25.35714rem;
  --px-360: 25.71429rem;
  --px-368: 26.28624rem;
  --px-370: 26.42857rem;
  --px-372: 26.57143rem;
  --px-373: 26.64286rem;
  --px-380: 27.14286rem;
  --px-385: 27.5rem;
  --px-390: 27.85714rem;
  --px-400: 28.57143rem;
  --px-410: 29.28571rem;
  --px-412: 29.42857rem;
  --px-420: 30rem;
  --px-423: 30.21429rem;
  --px-425: 30.35714rem;
  --px-440: 31.42857rem;
  --px-445: 31.78571rem;
  --px-450: 32.14286rem;
  --px-460: 32.85714rem;
  --px-461: 32.92857rem;
  --px-468: 33.42857rem;
  --px-475: 33.92857rem;
  --px-480: 34.28571rem;
  --px-500: 35.71429rem;
  --px-510: 36.42857rem;
  --px-511: 36.5rem;
  --px-515: 36.78571rem;
  --px-520: 37.14286rem;
  --px-525: 37.5rem;
  --px-530: 37.85714rem;
  --px-540: 38.57143rem;
  --px-541: 38.64286rem;
  --px-545: 38.92857rem;
  --px-550: 39.28571rem;
  --px-560: 40rem;
  --px-570: 40.71429rem;
  --px-580: 41.42857rem;
  --px-590: 42.14286rem;
  --px-600: 42.85714rem;
  --px-620: 44.28571rem;
  --px-640: 45.71429rem;
  --px-650: 46.42857rem;
  --px-656: 46.85714rem;
  --px-660: 47.14286rem;
  --px-689: 49.21429rem;
  --px-692: 49.42857rem;
  --px-698: 49.85714rem;
  --px-700: 50rem;
  --px-710: 50.71429rem;
  --px-730: 52.14286rem;
  --px-737: 52.64286rem;
  --px-740: 52.85714rem;
  --px-750: 53.57143rem;
  --px-780: 55.71429rem;
  --px-800: 57.14286rem;
  --px-825: 58.92857rem;
  --px-830: 59.28571rem;
  --px-840: 60rem;
  --px-870: 62.14286rem;
  --px-880: 62.85714rem;
  --px-900: 64.28571rem;
  --px-950: 67.85714rem;
  --px-980: 70rem;
  --px-1000: 71.42857rem;
  --px-1020: 72.85714rem;
  --px-1050: 75rem;
  --px-1100: 78.57143rem;
  --px-1110: 79.28571rem;
  --px-1140: 81.42857rem;
  --px-1152: 82.28571rem;
  --px-1170: 83.57143rem;
  --px-1200: 85.71429rem;
  --px-1330: 95rem;
  --px-1350: 96.42857rem;
  --px-1400: 100rem;
  --px-1430: 102.14286rem;
  --px-1500: 107.14286rem;
  --px-3000: 214.28571rem;
  --px-4000: 285.71429rem;
}
@font-face {
  font-family: 'EYInterstate';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@font-face {
  font-family: 'EYInterstate';
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
@font-face {
  font-family: 'EYInterstate';
  font-weight: bold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
@font-face {
  font-family: 'EYInterstate';
  font-style: italic;
  font-weight: bold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
@font-face {
  font-family: 'EYInterstate';
  font-weight: 300;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
/* default Global font sizes */
html {
  height: 100vh;
  width: 100%;
  font-size: 14px !important;
}
@media only screen and (min-width : 1367px) and (max-width : 1600px) {
  html {
    font-size: 12.61px !important;
  }
}
@media only screen and (min-width : 992px) and (max-width : 1366px) {
  html {
    font-size: 11.2px !important;
  }
}
@media only screen and (min-width : 768px) and (max-width : 991px) {
  html {
    font-size: 11.2px !important;
  }
}
body {
  height: 100%;
  width: 100%;
  overflow: hidden !important;
  margin: 0 auto;
  font-family: 'EYInterstate' !important;
  font-size: 14px !important;
}
@media only screen and (min-width : 1367px) and (max-width : 1600px) {
  body {
    font-size: 12.61px !important;
  }
}
@media only screen and (min-width : 992px) and (max-width : 1366px) {
  body {
    font-size: 11.2px !important;
  }
}
@media only screen and (min-width : 768px) and (max-width : 991px) {
  body {
    font-size: 11.2px !important;
  }
}
body * {
  font-family: 'EYInterstate';
}
h1 {
  font-size: var(--px-32);
  line-height: var(--px-32);
}
h2 {
  font-size: var(--px-30);
  line-height: var(--px-30);
}
h3 {
  font-size: var(--px-18);
  line-height: var(--px-18);
}
h4 {
  font-size: var(--px-16);
  line-height: var(--px-16);
}
h5 {
  font-size: var(--px-14);
  line-height: var(--px-14);
}
h6 {
  font-size: var(--px-12);
  line-height: var(--px-12);
}
label {
  line-height: var(--px-16);
}
.mainResponsiveWrapper {
  max-width: 2048px;
  padding-left: var(--px-40) !important;
}
@media only screen and (min-width : 768px) and (max-width : 991px) {
  .mainResponsiveWrapper {
    padding-left: var(--px-25) !important;
  }
}
@media only screen and (min-width : 992px) and (max-width : 1366px) {
  .mainResponsiveWrapper {
    padding-left: var(--px-25) !important;
  }
}
@media only screen and (min-width: 1921px) {
  .mainResponsiveWrapper {
    padding: 0 !important;
    position: relative !important;
  }
}
@media only screen and (min-width: 1921px) {
  .mainResponsiveWrapper .DraggableGuidance {
    left: 0 !important;
  }
}
@media only screen and (min-width: 1921px) {
  .mainResponsiveWrapper .DraggableComments {
    left: 30% !important;
  }
}
@media only screen and (min-width: 1921px) {
  .mainResponsiveWrapper.StyledTaskViewBreadcrumbs {
    padding-top: var(--px-20) !important;
    margin: 0 auto;
    padding-left: var(--px-126) !important;
  }
}
@media only screen and (min-width: 1921px) {
  .mainResponsiveWrapper.StyledAresViewFooter {
    height: var(--px-84) !important;
  }
}
@media only screen and (min-width: 1921px) {
  .mainResponsiveWrapper.StyledFormDetailsWrapper {
    padding: 0 var(--px-116) 0 var(--px-126) !important;
  }
}
@media only screen and (min-width: 1921px) {
  .mainResponsiveWrapper.StyledTaskDetailsWrapper {
    padding: 0 var(--px-116) 0 var(--px-126) !important;
  }
}
@media only screen and (min-width: 1921px) {
  .mainResponsiveWrapper.StyledAresFormBodyContainer {
    padding: var(--px-40) var(--px-116) 0 var(--px-126) !important;
  }
}
@media only screen and (min-width: 1921px) {
  .mainResponsiveWrapper.SectionTopNameWrapper {
    padding: 0 var(--px-116) 0 var(--px-126) !important;
  }
}
@media only screen and (min-width: 1921px) {
  .mainResponsiveWrapper.AresWrapper {
    padding: 0 var(--px-116) 0 var(--px-126) !important;
  }
}
.DrawerRootWrapper .MainContainerWrapper .mainResponsiveWrapper .formDataWrapper .rightSideSection .sectionCanvasForm .DraggableComments {
  top: 0 !important;
  left: 41% !important;
}
.DrawerRootWrapper #neon-skin.NeonDrawerView .StyledTaskViewWrapper .StyledTaskViewDetails .BodyContainerWrapper .mainResponsiveWrapper.StyledFormDetailsWrapper {
  padding-right: 0 !important;
}
.DrawerRootWrapper #neon-skin.NeonDrawerView .StyledTaskViewWrapper .StyledTaskViewDetails .BodyContainerWrapper .mainResponsiveWrapper.StyledFormDetailsWrapper .top-wrapper {
  padding: 0 var(--px-40) 0 0 !important;
}
.DrawerRootWrapper #neon-skin.NeonDrawerView .StyledTaskViewWrapper .StyledTaskViewDetails .BodyContainerWrapper .mainResponsiveWrapper.StyledFormDetailsWrapper .top-wrapper .bannerLabel {
  position: fixed;
  width: calc(90% - var(--px-50));
  left: var(--px-100);
  border-radius: var(--px-12);
  top: var(--px-18);
  z-index: 99;
  min-height: var(--px-46);
}
.DrawerRootWrapper #neon-skin .StyledTaskViewWrapper .StyledTaskViewDetails .BodyContainerWrapper .mainResponsiveWrapper {
  padding-left: var(--px-80) !important;
}
.DrawerRootWrapper #neon-skin .StyledTaskViewWrapper .StyledTaskViewDetails .BodyContainerWrapper .mainResponsiveWrapper.bodyDetailsViewContainer {
  padding-left: var(--px-40) !important;
}
@media only screen and (min-width: 999px) and (max-width: 1279px) {
  .DrawerRootWrapper #neon-skin .StyledTaskViewWrapper .StyledTaskViewDetails .BodyContainerWrapper .mainResponsiveWrapper {
    padding-left: var(--px-40) !important;
  }
}
@media only screen and (min-width: 1921px) {
  .DrawerRootWrapper #neon-skin .StyledTaskViewWrapper .StyledTaskViewDetails .BodyContainerWrapper .mainResponsiveWrapper {
    margin: 0 0 0 var(--px-60) !important;
    max-width: calc(100% - var(--px-60)) !important;
  }
}
.DrawerRootWrapper #neon-skin .StyledTaskViewWrapper .StyledTaskViewDetails .BodyContainerWrapper .mainResponsiveWrapper.StyledFormDetailsWrapper .top-wrapper {
  position: relative;
  margin-top: var(--px-10) !important;
  padding: 0 var(--px-80) 0 0 !important;
}
.DrawerRootWrapper #neon-skin .StyledTaskViewWrapper .StyledTaskViewDetails .BodyContainerWrapper .mainResponsiveWrapper.StyledTaskSummary .mainResponsiveWrapper.motif-breadcrumb.StyledTaskViewBreadcrumbs.StyledTaskViewBreadcrumbs {
  padding: 0 !important;
}
.DrawerRootWrapper #neon-skin .StyledTaskViewWrapper .StyledTaskViewDetails .BodyContainerWrapper .mainResponsiveWrapper .mainResponsiveWrapper {
  padding-left: var(--px-40) !important;
}
@media only screen and (min-width: 1921px) {
  .DrawerRootWrapper #neon-skin .StyledTaskViewWrapper .StyledTaskViewDetails .BodyContainerWrapper .mainResponsiveWrapper .mainResponsiveWrapper {
    margin: 0 !important;
    max-width: 100% !important;
  }
}
.DrawerRootWrapper #neon-skin .StyledTaskViewWrapper .StyledTaskViewDetails .BodyContainerWrapper .mainResponsiveWrapper .mainResponsiveWrapper.StyledFormDetailsWrapper,
.DrawerRootWrapper #neon-skin .StyledTaskViewWrapper .StyledTaskViewDetails .BodyContainerWrapper .mainResponsiveWrapper .mainResponsiveWrapper.SectionTopComponent,
.DrawerRootWrapper #neon-skin .StyledTaskViewWrapper .StyledTaskViewDetails .BodyContainerWrapper .mainResponsiveWrapper .mainResponsiveWrapper.SectionTopNameWrapper,
.DrawerRootWrapper #neon-skin .StyledTaskViewWrapper .StyledTaskViewDetails .BodyContainerWrapper .mainResponsiveWrapper .mainResponsiveWrapper.StyledAresFormBodyContainer {
  padding: 0 var(--px-40) 0 var(--px-20) !important;
}
.DrawerRootWrapper #neon-skin .StyledTaskViewWrapper .StyledTaskViewDetails .BodyContainerWrapper .mainResponsiveWrapper .mainResponsiveWrapper.StyledFormDetailsWrapper.BodyDetailsView,
.DrawerRootWrapper #neon-skin .StyledTaskViewWrapper .StyledTaskViewDetails .BodyContainerWrapper .mainResponsiveWrapper .mainResponsiveWrapper.SectionTopComponent.BodyDetailsView,
.DrawerRootWrapper #neon-skin .StyledTaskViewWrapper .StyledTaskViewDetails .BodyContainerWrapper .mainResponsiveWrapper .mainResponsiveWrapper.SectionTopNameWrapper.BodyDetailsView,
.DrawerRootWrapper #neon-skin .StyledTaskViewWrapper .StyledTaskViewDetails .BodyContainerWrapper .mainResponsiveWrapper .mainResponsiveWrapper.StyledAresFormBodyContainer.BodyDetailsView {
  padding: 0 !important;
  padding-left: var(--px-0) !important;
  padding-right: var(--px-40) !important;
}
.DrawerRootWrapper #neon-skin .StyledTaskViewWrapper .StyledTaskViewDetails .BodyContainerWrapper .mainResponsiveWrapper .mainResponsiveWrapper.motif-breadcrumb.StyledTaskViewBreadcrumbs.StyledTaskViewBreadcrumbs {
  padding: 0 0 0 var(--px-20) !important;
}
.DrawerRootWrapper #neon-skin .StyledTaskViewWrapper .StyledTaskViewDetails .BodyContainerWrapper .mainResponsiveWrapper .mainResponsiveWrapper.StyledAresViewFooter {
  padding: var(--px-20) var(--px-40) var(--px-20) var(--px-20) !important;
}
svg.extra-large {
  width: var(--px-36);
  height: var(--px-36);
  max-width: var(--px-36);
  max-height: var(--px-36);
}
svg.large {
  width: var(--px-24);
  height: var(--px-24);
  max-width: var(--px-24);
  max-height: var(--px-24);
}
svg.medium {
  width: var(--px-20);
  height: var(--px-20);
  max-width: var(--px-20);
  max-height: var(--px-20);
}
svg.small {
  width: var(--px-16);
  height: var(--px-16);
  max-width: var(--px-16);
  max-height: var(--px-16);
}
svg.disable {
  cursor: default;
  color: var(--neutrals-500);
  fill: var(--neutrals-500);
}
.error-message-wrapper {
  padding: 0;
  color: #2e2e38;
  display: table;
  width: 100%;
  font-size: var(--px-12);
  line-height: var(--px-18);
  border: var(--px-1) solid #7f7f7f;
}
.error-message-wrapper .error-message {
  display: table-cell;
  padding: var(--px-9) var(--px-10) var(--px-5);
  color: #2e2e38;
  background: #fff;
}
.errorIcon,
.success-icon,
.warning-icon,
.info-icon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) no-repeat var(--px-10) var(--px-10);
  width: var(--px-16);
  height: var(--px-16);
  padding: var(--px-18);
  display: table-cell;
  background-color: #b9251c;
  background-size: 50%;
}
.success-icon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat var(--px-7) var(--px-7);
  background-color: #2c973e;
}
.warning-icon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) no-repeat var(--px-9) var(--px-7);
  background-color: #ff9831;
}
.info-icon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) no-repeat var(--px-9) var(--px-7);
  background-color: #747480;
}
`, "",{"version":3,"sources":["webpack://./components/globals.less","webpack://./components/vars.less"],"names":[],"mappings":"AAAA;;;;;gBAKgB;AAChB;;EAEE;AACF,WAAW;AACX,WAAW;ACuEX;EACC,eAAA;ADrED;AC4FA;EACI,SAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,iBAAA;EACA,oBAAA;EACA,oBAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,oBAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,qBAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,gBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EACA,oBAAA;EACA,oBAAA;EACA,gBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,eAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACH,qBAAA;EACG,eAAA;EACA,qBAAA;EACA,qBAAA;EACA,iBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACH,qBAAA;EACA,qBAAA;EACG,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACH,qBAAA;EACG,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,qBAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACH,qBAAA;EACG,iBAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,qBAAA;EACH,qBAAA;EACG,qBAAA;EACH,qBAAA;EACG,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACH,iBAAA;EACG,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,iBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EACH,qBAAA;EACA,qBAAA;EACG,qBAAA;EACH,qBAAA;EACG,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACH,qBAAA;EACG,qBAAA;EACA,qBAAA;EACA,qBAAA;EACH,iBAAA;EACG,qBAAA;EACA,qBAAA;EACA,iBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,sBAAA;EACA,sBAAA;EACA,gBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;AD1FJ;AAjTA;EACC,2BAAA;EACA,4CAAA;AAmTD;AAjTA;EACC,2BAAA;EACA,kBAAA;EACA,4CAAA;AAmTD;AAjTA;EACC,2BAAA;EACA,iBAAA;EACA,4CAAA;AAmTD;AAjTA;EACC,2BAAA;EACA,kBAAA;EACA,iBAAA;EACA,4CAAA;AAmTD;AAjTA;EACC,2BAAA;EACA,gBAAA;EACA,4CAAA;AAmTD;AACA,8BAA8B;AAvR9B;EACC,aAAA;EACA,WAAA;EACA,0BAAA;AAyRD;AAxRC;EAAA;IACC,6BAAA;EA2RA;AACF;AA1RC;EAAA;IACC,4BAAA;EA6RA;AACF;AA5RC;EAAA;IACC,4BAAA;EA+RA;AACF;AA5RA;EACC,YAAA;EACA,WAAA;EACA,2BAAA;EACA,cAAA;EACA,sCAAA;EACA,0BAAA;AA8RD;AA7RC;EAAA;IACC,6BAAA;EAgSA;AACF;AA/RC;EAAA;IACC,4BAAA;EAkSA;AACF;AAjSC;EAAA;IACC,4BAAA;EAoSA;AACF;AAnTA;EAiBE,2BAAA;AAqSF;AAjSA;EACC,uBAAA;EACA,yBAAA;AAmSD;AAhSA;EACC,uBAAA;EACA,yBAAA;AAkSD;AA/RA;EACC,uBAAA;EACA,yBAAA;AAiSD;AA9RA;EACC,uBAAA;EACA,yBAAA;AAgSD;AA7RA;EACC,uBAAA;EACA,yBAAA;AA+RD;AA5RA;EACC,uBAAA;EACA,yBAAA;AA8RD;AA3RA;EACC,yBAAA;AA6RD;AA1RA;EACC,iBAAA;EACA,qCAAA;AA4RD;AA3RC;EAAA;IACC,qCAAA;EA8RA;AACF;AA7RC;EAAA;IACC,qCAAA;EAgSA;AACF;AA/RC;EAAA;IACC,qBAAA;IACA,6BAAA;EAkSA;AACF;AAhSE;EAAA;IACC,kBAAA;EAmSD;AACF;AAhSE;EAAA;IACC,oBAAA;EAmSD;AACF;AAhSE;EAAA;IACC,oCAAA;IACA,cAAA;IACA,sCAAA;EAmSD;AACF;AAhSE;EAAA;IACC,+BAAA;EAmSD;AACF;AAhSE;EAAA;IACC,mDAAA;EAmSD;AACF;AAhSE;EAAA;IACC,mDAAA;EAmSD;AACF;AAhSE;EAAA;IACC,8DAAA;EAmSD;AACF;AAhSE;EAAA;IACC,mDAAA;EAmSD;AACF;AAhSE;EAAA;IACC,mDAAA;EAmSD;AACF;AA/RA;EAOO,iBAAA;EACA,oBAAA;AA2RP;AA9QO;EACC,2BAAA;AAgRR;AAjRO;EAGE,sCAAA;AAiRT;AApRO;EAKG,eAAA;EACA,+BAAA;EACA,mBAAA;EACA,2BAAA;EACA,iBAAA;EACA,WAAA;EACA,wBAAA;AAkRV;AAlTA;EAgDM,qCAAA;AAqQN;AAxQM;EACC,qCAAA;AA0QP;AAvQM;EAAA;IACC,qCAAA;EA0QL;AACF;AAzQM;EAAA;IACC,qCAAA;IACA,+CAAA;EA4QL;AACF;AA3QM;EAEE,kBAAA;EACA,mCAAA;EACA,sCAAA;AA4QR;AAvQQ;EACC,qBAAA;AAyQT;AA3UA;EAuEO,qCAAA;AAuQP;AAtQO;EAAA;IACC,oBAAA;IACA,0BAAA;EAyQN;AACF;AAxQO;;;;EAIC,iDAAA;AA0QR;AAzQQ;;;;EACC,qBAAA;EACA,oCAAA;EACA,sCAAA;AA8QT;AA3QO;EACC,sCAAA;AA6QR;AA3QO;EACC,uEAAA;AA6QR;AAlQC;EACC,mBAAA;EACA,oBAAA;EACA,uBAAA;EACA,wBAAA;AAoQF;AAlQC;EACC,mBAAA;EACA,oBAAA;EACA,uBAAA;EACA,wBAAA;AAoQF;AAlQC;EACC,mBAAA;EACA,oBAAA;EACA,uBAAA;EACA,wBAAA;AAoQF;AAlQC;EACC,mBAAA;EACA,oBAAA;EACA,uBAAA;EACA,wBAAA;AAoQF;AAlQC;EACC,eAAA;EACA,0BAAA;EACA,yBAAA;AAoQF;AA5PA;EACC,UAAA;EACA,cAAA;EACA,cAAA;EACA,WAAA;EACA,uBAAA;EACA,yBAAA;EACA,iCAAA;AA8PD;AArQA;EASE,mBAAA;EACA,6CAAA;EACA,cAAA;EACA,gBAAA;AA+PF;AA3PA;;;;EAIC,uFAAA;EACA,mBAAA;EACA,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,yBAAA;EACA,oBAAA;AA6PD;AA1PA;EACC,qFAAA;EACA,yBAAA;AA4PD;AAzPA;EACC,qFAAA;EACA,yBAAA;AA2PD;AAxPA;EACC,qFAAA;EACA,yBAAA;AA0PD","sourcesContent":["/* rastwe: 10/17/17 - I'm adding an @import here to point at the\n *  EY Online Style Guide. This is required because of some issues with\n *  The \"extract-text-webpack-plugin\", or webpack itself. In either case,\n *  relying on the @import order instead of webpack fixes the issue.\n *  TODO: undo this later, and just refer to the OSG in the top-level\n *  component. */\n@import './vars';\n\n@font-face {\n\tfont-family: 'EYInterstate';\n\tsrc: url('../../assets/fonts/EYInterstate-Regular.ttf');\n}\n@font-face {\n\tfont-family: 'EYInterstate';\n\tfont-style: italic;\n\tsrc: url('../../assets/fonts/EYInterstate-Italic.ttf');\n}\n@font-face {\n\tfont-family: 'EYInterstate';\n\tfont-weight: bold;\n\tsrc: url('../../assets/fonts/EYInterstate-Bold.ttf');\n}\n@font-face {\n\tfont-family: 'EYInterstate';\n\tfont-style: italic;\n\tfont-weight: bold;\n\tsrc: url('../../assets/fonts/EYInterstate-BoldItalic.ttf');\n}\n@font-face {\n\tfont-family: 'EYInterstate';\n\tfont-weight: 300;\n\tsrc: url('../../assets/fonts/EYInterstate-Light.ttf');\n}\n\n/* default Global font sizes */\n\n// Small devices (phones, 320px and up)\n@mobile-default: ~'only screen and (min-width : 320x) and (max-width : 575px)';\n\n// Small devices (landscape phones, 576px and up)\n@mobile-large: ~'only screen and (min-width : 576px) and (max-width : 766px)';\n\n// All mobile devices (Mobiles, 768px and below)\n@all-mobiles: ~'only screen and (max-width : 767px)';\n\n// Medium devices (tablets, 768px and up)\n@tablet-default: ~'only screen and (min-width : 768px) and (max-width : 991px)';\n\n// Small desktops (small desktops, 992px and 1366px)\n@desktop-small: ~'only screen and (min-width : 992px) and (max-width : 1366px)';\n\n// Medium desktops (medium desktops, 1367px to 1600px)\n@desktop-medium: ~'only screen and (min-width : 1367px) and (max-width : 1600px)';\n\n// Large desktops (large desktops, 1200px and up)\n@desktop-default: ~'only screen and (min-width : 1200px)';\n\n// Extra large desktop (Extra large desktops, 1824px and up)\n@desktop-large: ~'only screen and (min-width : 1824px)';\n\nhtml {\n\theight: 100vh;// to apply background from ASU\n\twidth: 100%;\n\tfont-size: 14px !important;\n\t@media @desktop-medium {\n\t\tfont-size: 12.61px !important;\n\t}\n\t@media @desktop-small {\n\t\tfont-size: 11.2px !important;\n\t}\n\t@media @tablet-default {\n\t\tfont-size: 11.2px !important;\n\t}\n}\n\nbody {\n\theight: 100%;\n\twidth: 100%;\n\toverflow: hidden !important;\n\tmargin: 0 auto;\n\tfont-family: 'EYInterstate' !important;\n\tfont-size: 14px !important;\n\t@media @desktop-medium {\n\t\tfont-size: 12.61px !important;\n\t}\n\t@media @desktop-small {\n\t\tfont-size: 11.2px !important;\n\t}\n\t@media @tablet-default {\n\t\tfont-size: 11.2px !important;\n\t}\n\t* {\n\t\tfont-family: 'EYInterstate';\n\t}\n}\n\nh1 {\n\tfont-size: var(--px-32);\n\tline-height: var(--px-32);\n}\n\nh2 {\n\tfont-size: var(--px-30);\n\tline-height: var(--px-30);\n}\n\nh3 {\n\tfont-size: var(--px-18);\n\tline-height: var(--px-18);\n}\n\nh4 {\n\tfont-size: var(--px-16);\n\tline-height: var(--px-16);\n}\n\nh5 {\n\tfont-size: var(--px-14);\n\tline-height: var(--px-14);\n}\n\nh6 {\n\tfont-size: var(--px-12);\n\tline-height: var(--px-12);\n}\n\nlabel {\n\tline-height: var(--px-16);\n}\n\n.mainResponsiveWrapper {\n\tmax-width: 2048px;\n\tpadding-left: var(--px-40) !important;\n\t@media @tablet-default {\n\t\tpadding-left: var(--px-25) !important;\n\t}\n\t@media @desktop-small {\n\t\tpadding-left: var(--px-25) !important;\n\t}\n\t@media only screen and (min-width: 1921px) {\n\t\tpadding: 0 !important;\n\t\tposition: relative !important;\n\t}\n\t.DraggableGuidance {\n\t\t@media only screen and (min-width: 1921px) {\n\t\t\tleft: 0 !important;\n\t\t}\n\t}\n\t.DraggableComments {\n\t\t@media only screen and (min-width: 1921px) {\n\t\t\tleft: 30% !important;\n\t\t}\n\t}\n\t&.StyledTaskViewBreadcrumbs {\n\t\t@media only screen and (min-width: 1921px) {\n\t\t\tpadding-top: var(--px-20) !important;\n\t\t\tmargin: 0 auto;\n\t\t\tpadding-left: var(--px-126) !important;\n\t\t}\n\t}\n\t&.StyledAresViewFooter {\n\t\t@media only screen and (min-width: 1921px) {\n\t\t\theight: var(--px-84) !important;\n\t\t}\n\t}\n\t&.StyledFormDetailsWrapper {\n\t\t@media only screen and (min-width: 1921px) {\n\t\t\tpadding: 0 var(--px-116) 0 var(--px-126) !important;\n\t\t}\n\t}\n\t&.StyledTaskDetailsWrapper {\n\t\t@media only screen and (min-width: 1921px) {\n\t\t\tpadding: 0 var(--px-116) 0 var(--px-126) !important;\n\t\t}\n\t}\n\t&.StyledAresFormBodyContainer {\n\t\t@media only screen and (min-width: 1921px) {\n\t\t\tpadding: var(--px-40) var(--px-116) 0 var(--px-126) !important;\n\t\t}\n\t}\n\t&.SectionTopNameWrapper {\n\t\t@media only screen and (min-width: 1921px) {\n\t\t\tpadding: 0 var(--px-116) 0 var(--px-126) !important;\n\t\t}\n\t}\n\t&.AresWrapper {\n\t\t@media only screen and (min-width: 1921px) {\n\t\t\tpadding: 0 var(--px-116) 0 var(--px-126) !important;\n\t\t}\n\t}\n}\n\n.DrawerRootWrapper {\n\t.MainContainerWrapper {\n\t\t.mainResponsiveWrapper {\n\t\t\t.formDataWrapper {\n\t\t\t\t.rightSideSection {\n\t\t\t\t\t.sectionCanvasForm {\n\t\t\t\t\t\t.DraggableComments {\n\t\t\t\t\t\t\ttop: 0 !important;\n\t\t\t\t\t\t\tleft: 41% !important;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t#neon-skin {\n\t\t&.NeonDrawerView {\n\t\t\t.StyledTaskViewWrapper {\n\t\t\t\t.StyledTaskViewDetails {\n\t\t\t\t\t.BodyContainerWrapper {\n\t\t\t\t\t\t.mainResponsiveWrapper {\n\t\t\t\t\t\t\t&.StyledFormDetailsWrapper {\n\t\t\t\t\t\t\t\tpadding-right: 0 !important;\n\t\t\t\t\t\t\t\t.top-wrapper {\n\t\t\t\t\t\t\t\t\tpadding: 0 var(--px-40) 0 0 !important;\n\t\t\t\t\t\t\t\t\t.bannerLabel {\n\t\t\t\t\t\t\t\t\t\tposition: fixed;\n\t\t\t\t\t\t\t\t\t\twidth: calc(90% - var(--px-50));\n\t\t\t\t\t\t\t\t\t\tleft: var(--px-100);\n\t\t\t\t\t\t\t\t\t\tborder-radius: var(--px-12);\n\t\t\t\t\t\t\t\t\t\ttop: var(--px-18);\n\t\t\t\t\t\t\t\t\t\tz-index: 99;\n\t\t\t\t\t\t\t\t\t\tmin-height: var(--px-46);\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.StyledTaskViewWrapper {\n\t\t\t.StyledTaskViewDetails {\n\t\t\t\t.BodyContainerWrapper {\n\t\t\t\t\t.mainResponsiveWrapper {\n\t\t\t\t\t\t&.bodyDetailsViewContainer {\n\t\t\t\t\t\t\tpadding-left: var(--px-40) !important;\n\t\t\t\t\t\t}\n\t\t\t\t\t\tpadding-left: var(--px-80) !important;\n\t\t\t\t\t\t@media only screen and (min-width: 999px) and (max-width: 1279px) {\n\t\t\t\t\t\t\tpadding-left: var(--px-40) !important;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t@media only screen and (min-width: 1921px) {\n\t\t\t\t\t\t\tmargin: 0 0 0 var(--px-60) !important;\n\t\t\t\t\t\t\tmax-width: calc(100% - var(--px-60)) !important;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&.StyledFormDetailsWrapper {\n\t\t\t\t\t\t\t.top-wrapper {\n\t\t\t\t\t\t\t\tposition: relative;\n\t\t\t\t\t\t\t\tmargin-top: var(--px-10) !important;\n\t\t\t\t\t\t\t\tpadding: 0 var(--px-80) 0 0 !important;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&.StyledTaskSummary {\n\t\t\t\t\t\t\t.mainResponsiveWrapper {\n\t\t\t\t\t\t\t\t&.motif-breadcrumb.StyledTaskViewBreadcrumbs.StyledTaskViewBreadcrumbs {\n\t\t\t\t\t\t\t\t\tpadding: 0 !important;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.mainResponsiveWrapper {\n\t\t\t\t\t\t\tpadding-left: var(--px-40) !important;\n\t\t\t\t\t\t\t@media only screen and (min-width: 1921px) {\n\t\t\t\t\t\t\t\tmargin: 0 !important;\n\t\t\t\t\t\t\t\tmax-width: 100% !important;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&.StyledFormDetailsWrapper,\n\t\t\t\t\t\t\t&.SectionTopComponent,\n\t\t\t\t\t\t\t&.SectionTopNameWrapper,\n\t\t\t\t\t\t\t&.StyledAresFormBodyContainer {\n\t\t\t\t\t\t\t\tpadding: 0 var(--px-40) 0 var(--px-20) !important;\n\t\t\t\t\t\t\t\t&.BodyDetailsView {\n\t\t\t\t\t\t\t\t\tpadding: 0 !important;\n\t\t\t\t\t\t\t\t\tpadding-left: var(--px-0) !important;\n\t\t\t\t\t\t\t\t\tpadding-right: var(--px-40) !important;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&.motif-breadcrumb.StyledTaskViewBreadcrumbs.StyledTaskViewBreadcrumbs {\n\t\t\t\t\t\t\t\tpadding: 0 0 0 var(--px-20) !important;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&.StyledAresViewFooter {\n\t\t\t\t\t\t\t\tpadding: var(--px-20) var(--px-40) var(--px-20) var(--px-20) !important;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\nsvg {\n\t&.extra-large {\n\t\twidth: var(--px-36);\n\t\theight: var(--px-36);\n\t\tmax-width: var(--px-36);\n\t\tmax-height: var(--px-36);\n\t}\n\t&.large {\n\t\twidth: var(--px-24);\n\t\theight: var(--px-24);\n\t\tmax-width: var(--px-24);\n\t\tmax-height: var(--px-24);\n\t}\n\t&.medium {\n\t\twidth: var(--px-20);\n\t\theight: var(--px-20);\n\t\tmax-width: var(--px-20);\n\t\tmax-height: var(--px-20);\n\t}\n\t&.small {\n\t\twidth: var(--px-16);\n\t\theight: var(--px-16);\n\t\tmax-width: var(--px-16);\n\t\tmax-height: var(--px-16);\n\t}\n\t&.disable {\n\t\tcursor: default;\n\t\tcolor: var(--neutrals-500);\n\t\tfill: var(--neutrals-500);\n\t}\n}\n\n// input:-webkit-autofill {\n// \t-webkit-box-shadow: 0 0 0 var(--px-1000) white inset;\n// }\n\n.error-message-wrapper {\n\tpadding: 0;\n\tcolor: #2e2e38;\n\tdisplay: table;\n\twidth: 100%;\n\tfont-size: var(--px-12);\n\tline-height: var(--px-18);\n\tborder: var(--px-1) solid #7f7f7f;\n\t.error-message {\n\t\tdisplay: table-cell;\n\t\tpadding: var(--px-9) var(--px-10) var(--px-5);\n\t\tcolor: #2e2e38;\n\t\tbackground: #fff;\n\t}\n}\n\n.errorIcon,\n.success-icon,\n.warning-icon,\n.info-icon {\n\tbackground: url('../images/error-icon.svg') no-repeat var(--px-10) var(--px-10);\n\twidth: var(--px-16);\n\theight: var(--px-16);\n\tpadding: var(--px-18);\n\tdisplay: table-cell;\n\tbackground-color: #b9251c;\n\tbackground-size: 50%;\n}\n\n.success-icon {\n\tbackground: url('../images/success-icon.svg') no-repeat var(--px-7) var(--px-7);\n\tbackground-color: #2c973e;\n}\n\n.warning-icon {\n\tbackground: url('../images/warning-icon.png') no-repeat var(--px-9) var(--px-7);\n\tbackground-color: #ff9831;\n}\n\n.info-icon {\n\tbackground: url('../images/info-icon.png') no-repeat var(--px-9) var(--px-7);\n\tbackground-color: #747480;\n}\n","/**\n * Global LESS variables\n */\n\n/* Colors */\n@ey-black: #000;\n@ey-buttercup: #ffee99;\n@ey-green: #2c973e;\n@ey-green-50: #95cb89;\n@ey-lilac: #ac98db;\n@ey-lilac-50: #d8d2e0;\n@ey-link-blue: #336699;\n@ey-link-blue-50: #7fd1d6;\n@ey-purple: #91278f;\n@ey-purple-50: #c893c7;\n@ey-red: #f04c3e;\n@ey-white: #fff;\n@ey-yellow: #ffd200;\n@ey-orange: #f7941d;\n@gray-light: #f0f0f0;\n@gray: #c0c0c0;\n@gray-half: #81858b;\n@gray-34th: #44494f;\n@gray-dark: #24282d;\n@gray-charcoal: #333;\n@grey-50: #3b3838;\n@grey-70: #7f7f7f;\n@ey-sky-blue: #35b7c0;\n@ey-teal: #00a3ae;\n@gray-100: #44494f;\n@grey-light-bg: #f4f4f4;\n@gray-14th: #bec1c7;\n@ey-ready-green: #00a4ae;\n@ey-inqueuebadge: #fcd5b5;\n@ey-inprogressbadge: #d7e4bd;\n/* Layout */\n@footer-height: (@nav-height / 4) + @footer-padding * 2;\n@footer-padding: 5px;\n@nav-height: 80px;\n@screen-xs: 480px;\n@screen-sm: 768px;\n@screen-md: 992px;\n@screen-lg: 1200px;\n@label-font-weight: bold;\n@cursor-disabled: default;\n@labelWeightNormal: normal;\n@z-index-select-dropdown: 1060; // must be higher than a modal background (1050)\n//** Placeholder text color\n@input-color-placeholder: #999;\n@channelToolsWidth: 100%;\n@baseFontSize: 12px;\n@label-font-weight: bold;\n@toggleButtonBorder: #d9dadb;\n@toggleActiveButton: #ffe600;\n@buttonBorderRadius: 4px;\n@inputBorderRadius: 4px;\n@textColorWhite: #fff;\n@inputActiveBorder: #f7941d;\n@label-font-weight: bold;\n@baseVMFontSize: 0.77vw;\n@label-placeholder-color: #81858b;\n@formComponentHeight: 30px;\n@typeaheadTokenColor: #e7f4ff;\n@typeheadLabelColor: #1f8dd6;\n@typeheadDisabledColor: #ddd;\n@typeheadSelectedColor: #1f8dd6;\n@buttonDisabled: #ddd;\n@buttonActiveBorder: #bde7ea;\n@opacity-transparent: 1;\n@opacity-blur: 0.8;\n@ey-border-radius: 4px;\n@cursor-default: default;\n@cursor-pointer: pointer;\n@boxshadow-none: none;\n@display-inline: inline-block;\n@typeahead-background: #646464;\n@baseFormLineHeight: 32px;\n@global100Percent: 100%;\n@globalRadius: 0;\n@bg-disabled: #eee;\n\n.global-lh-pd-fs {\n\tpadding: 0 10px;\n}\n\n// Small devices (phones, 320px and up)\n@mobile-default: ~'only screen and (min-width : 320x)';\n\n// Small devices (landscape phones, 576px and up)\n@mobile-large: ~'only screen and (min-width : 576px)';\n\n// Medium devices (tablets, 768px and up)\n@tablet-default: ~'only screen and (min-width : 768px)';\n\n// Large devices (desktops, 992px and up)\n@desktop-small: ~'only screen and (min-width : 992px)';\n\n// Large desktops (large desktops, 1200px and up)\n@desktop-default: ~'only screen and (min-width : 1200px)';\n\n// Extra large desktop (large desktops, 1824px and up)\n@desktop-large: ~'only screen and (min-width : 1824px)';\n\n\n\n:root {\n    --px-0: 0;\n    --px-0_1: 0.00714rem;\n    --px-0_2: 0.01429rem;\n    --px-0_3: 0.02143rem;\n    --px-0_4: 0.02857rem;\n    --px-0_5: 0.03571rem;\n    --px-0_6: 0.04286rem;\n    --px-0_7: 0.05rem;\n    --px-0_8: 0.05714rem;\n    --px-0_9: 0.06429rem;\n    --px-1: 0.07143rem;\n    --px-1_5: 0.10714rem;\n    --px-2: 0.14286rem;\n    --px-2_5: 0.17857rem;\n    --px-3: 0.21429rem;\n    --px-3_5: 0.25rem;\n    --px-3_7: 0.26429rem;\n    --px-4: 0.28571rem;\n    --px-4_5: 0.32143rem;\n    --px-5: 0.35714rem;\n    --px-6: 0.42857rem;\n    --px-6_5: 0.46429rem;\n    --px-7: 0.5rem;\n    --px-7_5: 0.53571rem;\n    --px-8: 0.57143rem;\n    --px-8_5: 0.60714rem;\n    --px-9: 0.64286rem;\n    --px-10: 0.71429rem;\n    --px-11: 0.78571rem;\n    --px-11_5: 0.82143rem;\n    --px-12: 0.85714rem;\n    --px-12_5: 0.89286rem;\n    --px-12_6: 0.9rem;\n    --px-13: 0.92857rem;\n    --px-13_5: 0.96429rem;\n    --px-14: 1rem;\n    --px-14_4: 1.02857rem;\n    --px-15: 1.07143rem;\n    --px-15_5: 1.10714rem;\n    --px-16: 1.14286rem;\n    --px-16_5: 1.17857rem;\n    --px-16_8: 1.2rem;\n    --px-17: 1.21429rem;\n    --px-17_5: 1.25rem;\n    --px-18: 1.28571rem;\n    --px-19: 1.35714rem;\n    --px-19_2: 1.37143rem;\n    --px-20: 1.42857rem;\n    --px-21: 1.5rem;\n    --px-21_5: 1.53571rem;\n    --px-22: 1.57143rem;\n    --px-22_5: 1.60714rem;\n    --px-23: 1.64286rem;\n    --px-23_5: 1.67857rem;\n    --px-24: 1.71429rem;\n    --px-25: 1.78571rem;\n    --px-26: 1.85714rem;\n    --px-27: 1.92857rem;\n    --px-28: 2rem;\n    --px-29: 2.07143rem;\n    --px-30: 2.14286rem;\n    --px-31: 2.21429rem;\n    --px-32: 2.28571rem;\n    --px-33: 2.35714rem;\n    --px-34: 2.42857rem;\n    --px-35: 2.5rem;\n    --px-36: 2.57143rem;\n    --px-37: 2.64286rem;\n    --px-38: 2.71429rem;\n    --px-39: 2.78571rem;\n    --px-40: 2.85714rem;\n    --px-41: 2.92857rem;\n    --px-42: 3rem;\n    --px-43: 3.07143rem;\n    --px-44: 3.14286rem;\n    --px-45: 3.21429rem;\n    --px-46: 3.28571rem;\n    --px-47: 3.35714rem;\n    --px-48: 3.42857rem;\n    --px-49: 3.5rem;\n    --px-50: 3.57143rem;\n    --px-52: 3.71429rem;\n    --px-53: 3.78571rem;\n    --px-54: 3.85714rem;\n    --px-55: 3.92857rem;\n    --px-56: 4rem;\n    --px-57: 4.07143rem;\n    --px-58: 4.14286rem;\n    --px-60: 4.28571rem;\n    --px-61: 4.35714rem;\n    --px-62: 4.42857rem;\n    --px-64: 4.57143rem;\n    --px-65: 4.64286rem;\n    --px-66: 4.71429rem;\n    --px-67: 4.78571rem;\n    --px-68: 4.85714rem;\n    --px-70: 5rem;\n    --px-71: 5.07143rem;\n    --px-72: 5.14286rem;\n    --px-74: 5.28571rem;\n    --px-75: 5.35714rem;\n    --px-76: 5.42857rem;\n    --px-77: 5.5rem;\n    --px-78: 5.57143rem;\n    --px-80: 5.71429rem;\n    --px-82: 5.85714rem;\n    --px-83: 5.92857rem;\n    --px-84: 6rem;\n    --px-85: 6.07143rem;\n    --px-87: 6.21429rem;\n    --px-88: 6.28571rem;\n    --px-90: 6.42857rem;\n    --px-91_5: 6.53571rem;\n    --px-92: 6.57143rem;\n    --px-94: 6.71429rem;\n    --px-95: 6.78571rem;\n    --px-98: 7rem;\n    --px-100: 7.14286rem;\n    --px-101: 7.21429rem;\n    --px-102: 7.28571rem;\n    --px-105: 7.5rem;\n    --px-108: 7.71429rem;\n    --px-110: 7.85714rem;\n    --px-112: 8rem;\n    --px-115: 8.21429rem;\n    --px-116: 8.28571rem;\n    --px-120: 8.57143rem;\n    --px-121: 8.64286rem;\n    --px-122: 8.71429rem;\n    --px-123: 8.78571rem;\n    --px-125: 8.92857rem;\n    --px-126: 9rem;\n    --px-127: 9.07143rem;\n    --px-130: 9.28571rem;\n    --px-133: 9.5rem;\n    --px-134: 9.57143rem;\n    --px-135: 9.64286rem;\n    --px-136: 9.71429rem;\n    --px-138: 9.85714rem;\n    --px-140: 10rem;\n    --px-142: 10.14286rem;\n    --px-145: 10.35714rem;\n    --px-149: 10.64286rem;\n    --px-150: 10.71429rem;\n    --px-154: 11rem;\n    --px-155: 11.07143rem;\n    --px-158: 11.28571rem;\n    --px-160: 11.42857rem;\n    --px-162: 11.57143rem;\n    --px-163: 11.64286rem;\n    --px-165: 11.78571rem;\n\t--px-166: 11.85714rem;\n    --px-168: 12rem;\n    --px-170: 12.14286rem;\n    --px-173: 12.35714rem;\n    --px-175: 12.5rem;\n    --px-176: 12.57143rem;\n    --px-178: 12.71429rem;\n    --px-180: 12.85714rem;\n    --px-184: 13.14286rem;\n    --px-185: 13.21429rem;\n\t--px-186: 13.28571rem;\n\t--px-187: 13.35714rem;\n    --px-188: 13.42857rem;\n    --px-190: 13.57143rem;\n    --px-191: 13.64286rem;\n    --px-193: 13.78571rem;\n    --px-194: 13.85714rem;\n\t--px-195: 13.92857rem;\n    --px-198: 14.14286rem;\n    --px-200: 14.28571rem;\n    --px-205: 14.64286rem;\n    --px-206: 14.71429rem;\n    --px-207: 14.78571rem;\n    --px-208: 14.85714rem;\n    --px-210: 15rem;\n    --px-211: 15.07143rem;\n    --px-211_5: 15.10714rem;\n    --px-212: 15.14286rem;\n    --px-214: 15.28571rem;\n    --px-215: 15.35714rem;\n    --px-216: 15.42857rem;\n    --px-220: 15.71429rem;\n    --px-225: 16.07143rem;\n    --px-230: 16.42857rem;\n    --px-232: 16.57143rem;\n    --px-235: 16.78571rem;\n    --px-240: 17.14286rem;\n\t--px-244: 17.42857rem;\n    --px-245: 17.5rem;\n    --px-250: 17.85714rem;\n    --px-251: 17.92857rem;\n    --px-252: 18rem;\n    --px-255: 18.21429rem;\n\t--px-257: 18.35714rem;\n    --px-260: 18.57143rem;\n\t--px-265: 18.92857rem;\n    --px-270: 19.28571rem;\n    --px-272: 19.42857rem;\n    --px-275: 19.64286rem;\n    --px-280: 20rem;\n    --px-282: 20.14286rem;\n    --px-285: 20.35714rem;\n    --px-290: 20.71429rem;\n    --px-293: 20.92857rem;\n    --px-300: 21.42857rem;\n    --px-305: 21.78571rem;\n    --px-310: 22.14286rem;\n\t--px-315: 22.5rem;\n    --px-316: 22.57143rem;\n    --px-320: 22.85714rem;\n    --px-322: 23rem;\n    --px-324: 23.14286rem;\n    --px-325: 23.21429rem;\n    --px-328: 23.42857rem;\n    --px-330: 23.57143rem;\n    --px-340: 24.28571rem;\n    --px-350: 25rem;\n    --px-354: 25.28571rem;\n    --px-355: 25.35714rem;\n    --px-360: 25.71429rem;\n    --px-368: 26.28624rem;\n    --px-370: 26.42857rem;\n    --px-372: 26.57143rem;\n    --px-373: 26.64286rem;\n    --px-380: 27.14286rem;\n    --px-385: 27.5rem;\n    --px-390: 27.85714rem;\n    --px-400: 28.57143rem;\n    --px-410: 29.28571rem;\n    --px-412: 29.42857rem;\n    --px-420: 30rem;\n\t--px-423: 30.21429rem;\n\t--px-425: 30.35714rem;\n    --px-440: 31.42857rem;\n\t--px-445: 31.78571rem;\n    --px-450: 32.14286rem;\n    --px-460: 32.85714rem;\n    --px-461: 32.92857rem;\n    --px-468: 33.42857rem;\n\t--px-475: 33.92857rem;\n    --px-480: 34.28571rem;\n    --px-500: 35.71429rem;\n    --px-510: 36.42857rem;\n\t--px-511: 36.5rem;\n    --px-515: 36.78571rem;\n    --px-520: 37.14286rem;\n    --px-525: 37.5rem;\n    --px-530: 37.85714rem;\n    --px-540: 38.57143rem;\n    --px-541: 38.64286rem;\n    --px-545: 38.92857rem;\n    --px-550: 39.28571rem;\n    --px-560: 40rem;\n    --px-570: 40.71429rem;\n    --px-580: 41.42857rem;\n    --px-590: 42.14286rem;\n    --px-600: 42.85714rem;\n    --px-620: 44.28571rem;\n    --px-640: 45.71429rem;\n    --px-650: 46.42857rem;\n    --px-656: 46.85714rem;\n    --px-660: 47.14286rem;\n    --px-689: 49.21429rem;\n    --px-692: 49.42857rem;\n    --px-698: 49.85714rem;\n    --px-700: 50rem;\n    --px-710: 50.71429rem;\n    --px-730: 52.14286rem;\n    --px-737: 52.64286rem;\n    --px-740: 52.85714rem;\n    --px-750: 53.57143rem;\n    --px-780: 55.71429rem;\n    --px-800: 57.14286rem;\n    --px-825: 58.92857rem;\n    --px-830: 59.28571rem;\n    --px-840: 60rem;\n    --px-870: 62.14286rem;\n    --px-880: 62.85714rem;\n    --px-900: 64.28571rem;\n    --px-950: 67.85714rem;\n    --px-980: 70rem;\n    --px-1000: 71.42857rem;\n    --px-1020: 72.85714rem;\n    --px-1050: 75rem;\n    --px-1100: 78.57143rem;\n    --px-1110: 79.28571rem;\n    --px-1140: 81.42857rem;\n    --px-1152: 82.28571rem;\n    --px-1170: 83.57143rem;\n    --px-1200: 85.71429rem;\n    --px-1330: 95rem;\n    --px-1350: 96.42857rem;\n    --px-1400: 100rem;\n    --px-1430: 102.14286rem;\n    --px-1500: 107.14286rem;\n    --px-3000: 214.28571rem;\n    --px-4000: 285.71429rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
